import React from 'react';

export default function Features() {
    const features = [
        { title: "Atendimento Rápido", desc: "Respondo em horas via WhatsApp ou email" },
        { title: "Foco em Resultados", desc: "Seu sucesso é meu sucesso" },
        { title: "Metodologia Ágil", desc: "Entregas rápidas com qualidade garantida" },
        { title: "Suporte Dedicado", desc: "Não desapareço após o lançamento" },
        { title: "Transparência Total", desc: "Você acompanha todo o processo" },
        { title: "Preços Justos", desc: "Sem cobranças escondidas" },
    ];

    return (
        <section className="py-20 px-4 bg-black text-white">
            <div className="max-w-4xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                    Por que escolher a <span className="text-green-500">Roldan Eng. Software</span>?
                </h2>
                <div className="grid md:grid-cols-2 gap-8">
                    {features.map((feature, idx) => (
                        <div key={idx} className="flex gap-4">
                            <div className="text-cyan-400 text-3xl flex-shrink-0">✓</div>
                            <div>
                                <h3 className="font-bold text-lg mb-2">{feature.title}</h3>
                                <p className="text-gray-300">{feature.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
